const domainConfig = {
  maxAge: 80,
  minAge: 18,
  personNameRegExp: /^[a-zA-Z\u00C0-\u017F\s]+$/gu,
  phoneNumberRegExp: /^07(0|1|2|3|6|9)\d{7}$/g,
  emailRegExp: /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)*\.[A-Za-z]{2,6}$/,
  personalIDRegExp: /^(\d{6}-\d{4})$/g,
};

export const PRODUCT_NUMBER = '15';
export const TERM = 35;
export const MIN_LOAN_AMOUNT = 2000;
export const MAX_LOAN_AMOUNT = 10000;
export default domainConfig;
